/* Token completi delle 3 proposte + dataset condiviso per le viste mobile per ruolo. */

export const PROPOSALS = {
  a: {
    id: 'a',
    name: 'Operational',
    bg: '#FAFAFA',
    surface: '#FFFFFF',
    primary: '#000000',
    accent: '#0052FF',
    border: '#E5E5E5',
    muted: '#737373',
    text: '#111111',
    success: '#17B877',
    warning: '#F5A623',
    danger: '#E01E5A',
    fontDisplay: '"Cabinet Grotesk", "Space Grotesk", sans-serif',
    fontBody: '"IBM Plex Sans", system-ui, sans-serif',
    fontMono: '"IBM Plex Mono", monospace',
    radius: '0px',
    cardBorder: '1px solid #E5E5E5',
    cardShadow: 'none',
  },
  b: {
    id: 'b',
    name: 'Boutique',
    bg: '#F7F5F0',
    surface: '#FFFFFF',
    primary: '#2C3E3A',
    accent: '#C19A6B',
    border: '#EAE6DF',
    muted: '#6E6B65',
    text: '#1A1A1A',
    success: '#2D7A5D',
    warning: '#D48B3E',
    danger: '#A63C3C',
    fontDisplay: '"Cormorant Garamond", serif',
    fontBody: '"Outfit", sans-serif',
    fontMono: '"Outfit", sans-serif',
    radius: '22px',
    cardBorder: 'none',
    cardShadow: '0 1px 2px rgba(44,62,58,0.04), 0 6px 18px rgba(44,62,58,0.06)',
  },
  c: {
    id: 'c',
    name: 'Data Intel',
    bg: '#09090B',
    surface: '#121214',
    surface2: '#1A1A1D',
    primary: '#FFFFFF',
    accent: '#3B82F6',
    accentGlow: 'rgba(59,130,246,0.18)',
    border: '#27272A',
    muted: '#94A3B8',
    mutedDim: '#52525B',
    text: '#F8FAFC',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    fontDisplay: '"Clash Display", "Space Grotesk", sans-serif',
    fontBody: '"Manrope", sans-serif',
    fontMono: '"JetBrains Mono", monospace',
    radius: '10px',
    cardBorder: '1px solid #27272A',
    cardShadow: 'none',
  },
};

export const MOCK_FO = {
  user: 'Anna Verdi',
  myOpen: [
    { id: '#3412', title: 'Climatizzatore in tilt', room: '405', status: 'in_lavorazione', age: '12m' },
    { id: '#3389', title: 'TV non accende', room: '208', status: 'assegnato', age: '2h 30m' },
    { id: '#3381', title: 'Doccia gocciola', room: '511', status: 'in_lavorazione', age: '4h' },
  ],
  closed: [
    { id: '#3372', title: 'Lampadina bagno', room: '208', closedAt: 'ieri' },
    { id: '#3365', title: 'Cassaforte bloccata', room: '301', closedAt: '2 giorni fa' },
  ],
};

export const MOCK_HK = {
  user: 'Carla Russo',
  todayRooms: 14,
  doneRooms: 5,
  rooms: [
    { num: '101', state: 'da_pulire', guest: 'Check-out 11:00', priority: 'high' },
    { num: '102', state: 'da_pulire', guest: 'Check-out 11:30', priority: 'high' },
    { num: '203', state: 'occupata', guest: 'M. Rossi · stay-over', priority: 'med' },
    { num: '204', state: 'pulita', guest: '—', priority: 'low' },
    { num: '305', state: 'da_pulire', guest: 'Check-out 12:00', priority: 'med' },
    { num: '306', state: 'fuori_servizio', guest: 'Manutenzione idraulica', priority: 'low' },
    { num: '402', state: 'occupata', guest: 'L. Bianchi · stay-over', priority: 'low' },
  ],
};

export const MOCK_TECH = {
  user: 'Mario Rossi',
  today: 4,
  done: 1,
  next: {
    id: '#3412',
    title: 'Climatizzatore in tilt',
    room: '405',
    floor: '4° piano',
    priority: 'urgente',
    age: '12m',
    note: 'Cliente segnala rumore continuo + niente raffreddamento. Prova prima il filtro.',
    photos: 2,
  },
  queue: [
    { id: '#3401', title: 'Ascensore B fermo p.4', room: 'Asc-B', priority: 'urgente', age: '1h 12m' },
    { id: '#3389', title: 'TV non accende', room: '208', priority: 'media', age: '2h 30m' },
    { id: '#3382', title: 'Frigobar non raffredda', room: '317', priority: 'media', age: '3h 05m' },
  ],
};
